import { useQuery } from '@tanstack/react-query';
import { AuthContext, PaginationSpec } from 'alurkerja-ui';
import { useContext, useState } from 'react';
import _ from 'lodash';
import { env } from '@/utils/constants/env';

interface UseFetch {
  path: string;
  query?: string;
  waitFor?: boolean;
}

interface UseFetchResult<T> {
  data: T | undefined;
  isLoading: boolean;
  pagination?: PaginationSpec;
  refetch: () => Promise<any>;
  isFetching: boolean;
}

export const useFetch = <T>({ path, query, waitFor = true }: UseFetch): UseFetchResult<T> => {
  const axios = useContext(AuthContext);
  axios.defaults.baseURL = env.apiBaseUrl;

  const [pagination, setPagination] = useState<any>();

  const { data, isLoading, refetch, isFetching } = useQuery<T>({
    queryKey: [...path.split('/').slice(1, path.length), query],
    queryFn: async () => {
      let url = path;
      if (query) {
        url += '?' + query;
      }
      return axios.get(url).then(res => {
        setPagination(_.omit(res.data.data, ['content']));
        return res.data.data;
      });
    },
    enabled: waitFor,
  });

  return { data, pagination: pagination, isLoading, refetch, isFetching };
};
